import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from '../../../../common/model/api.query';
import { task } from '../model/task.fragments';
import { TaskOutput } from '../model/task.output';

export interface FetchJobOfferTasksParams {
	readonly jobOfferId: string;
}

@Injectable({ providedIn: 'root' })
export class FetchJobOfferTasksApiQuery extends ApiQuery<
	TaskOutput[],
	FetchJobOfferTasksParams
> {
	client = 'iam';
	document = gql`
		query FetchJobOfferTasks($jobOfferId: UUID!) {
			fetchJobOfferTasks(jobOfferId: $jobOfferId) {
				...Task
			}
		}
		${task}
	`;
	method = 'fetchJobOfferTasks';
}
